module.exports = __webpack_public_path__ + "static/media/angle-arrow-down.8e2c6296.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-down.svg
// module id = 554
// module chunks = 0